import { mutatorAction } from "satcheljs";
import { SchedulesViewStateStore } from "../store/schema/SchedulesViewStateStore";
import { IPreviewSchedulePageStore } from "../../../previewSchedulePage";
import schedulesViewStateStore from "../store/store";

/**
 * Sets the isViewStatePopulated flag on the viewState
 */
export default mutatorAction("SET_IS_VIEW_STATE_POPULATED",
    function setIsViewStatePopulated(
        isPopulated: boolean,
        viewState?: SchedulesViewStateStore | IPreviewSchedulePageStore
    ) {
        (viewState ? viewState : schedulesViewStateStore()).isViewStatePopulated = isPopulated;
    });